import { useState } from "react";

// styles
import "../project/Project.css";

const filters = ["all", "cost mismatch", "issues", "weight diff"];
const customerFilters = ["all", "cost mismatch"];

export default function InvoiceDetailFilter({
  loads,
  setVisibleLoads,
  type,
  isCustomer,
  customerFilter,
  setCustomerfilter,
  loadsMap,
}) {
  const [currFilter, setCurrFilter] = useState("all");
  const handleClick = (newFilter) => {
    setCurrFilter(newFilter);
    let vis = [];
    switch (newFilter) {
      case "all":
        vis = loads;
        break;
      case "cost mismatch":
        loads.forEach((l) => {
          if (loadsMap[l.load_id]['cost_mismatch']) {
            vis.push(l);
          }
        });
        break;
      case "issues":
        loads.forEach((l) => {
          if (type !== "asset") {
            if (
              loadsMap[l.load_id]['matching_load_numbers'].length > 1 ||
              loadsMap[l.load_id]['locked_reason'] !== "" ||
              loadsMap[l.load_id]['missing_ticket']
            ) {
              vis.push(l);
            }
          } else {
            if (l.locked_reason !== "") {
              vis.push(l);
            }
          }
        });
        break;
      case "weight diff":
        loads.forEach((l) => {
          if (loadsMap[l.load_id]['weight_diff'] > 0.01 || loadsMap[l.load_id]['weight_diff'] < -0.01) {
            vis.push(l);
          }
        });
        break;
      default:
        break;
    }
    setVisibleLoads(vis);
  };

  const handleCustomerClick = (newFilter) => {
    setCustomerfilter(newFilter);
  };

  return !isCustomer ? (
    <div className="filter">
      <nav>
        {filters.map((f) => (
          <button
            key={f}
            className={currFilter === f ? "active" : ""}
            onClick={() => handleClick(f)}
          >
            {f}
          </button>
        ))}
      </nav>
    </div>
  ) : (
    <div className="filter">
      <nav>
        {customerFilters.map((f) => (
          <button
            key={f}
            className={customerFilter === f ? "active" : ""}
            onClick={() => handleCustomerClick(f)}
          >
            {f}
          </button>
        ))}
      </nav>
    </div>
  );
}
